"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _firebase = _interopRequireDefault(require("firebase"));
var _default = exports.default = {
  methods: {
    uploadFileToStorage: function () {
      var _uploadFileToStorage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(file, savePath) {
        var fileURL, storageRef;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              fileURL = null;
              storageRef = _firebase.default.storage().ref().child(savePath);
              _context2.next = 1;
              return storageRef.put(file).then(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(snapshot) {
                  return regeneratorRuntime.wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        console.log('uploadFileToStorage[put success]');
                        _context.next = 1;
                        return snapshot.ref.getDownloadURL().then(function (downloadURL) {
                          fileURL = downloadURL;
                        }, function (error) {
                          console.log(error);
                        });
                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x3) {
                  return _ref.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });
            case 1:
              console.log('uploadFileToStorage[end]');
              return _context2.abrupt("return", fileURL);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function uploadFileToStorage(_x, _x2) {
        return _uploadFileToStorage.apply(this, arguments);
      }
      return uploadFileToStorage;
    }(),
    deleteFileFromStorage: function () {
      var _deleteFileFromStorage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(savePath) {
        var isDeleted, storageRef;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              isDeleted = false;
              storageRef = _firebase.default.storage().ref().child(savePath);
              _context4.next = 1;
              return storageRef.delete().then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function (_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      console.log('deleteFileFromStorage[success]');
                      isDeleted = true;
                    case 1:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              })), function (error) {
                console.log(error);
              });
            case 1:
              console.log('deleteFileFromStorage[end]');
              return _context4.abrupt("return", isDeleted);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function deleteFileFromStorage(_x4) {
        return _deleteFileFromStorage.apply(this, arguments);
      }
      return deleteFileFromStorage;
    }()
  }
};